import { render, staticRenderFns } from "./CostPlanBreakdownMaterials.vue?vue&type=template&id=6aba9c30&"
import script from "./CostPlanBreakdownMaterials.vue?vue&type=script&lang=js&"
export * from "./CostPlanBreakdownMaterials.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports